/**
 * What an entry is, by colour — the same in every builder box and in the
 * onboarding and concierge previews: blue for a ticker, violet for a keyword,
 * green for a tag, and neutral with the list's own colour dot for a whole
 * watchlist.
 */
export type ChipKind = "ticker" | "keyword" | "tag" | "list";

export const CHIP_TONE: Record<ChipKind, string> = {
  ticker: "border-blue-400/30 bg-blue-900/30 text-blue-200",
  keyword: "border-purple-400/30 bg-purple-900/30 text-purple-200",
  tag: "border-green-400/30 bg-green-900/40 text-green-200",
  list: "border-gray-600 bg-gray-800 text-gray-200",
};
